<template>
    <div class="-my-2 md:-mx-6 lg:-mx-8">
        <div v-if="isLoading" class="w-10 h-10 mt-20 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
        <div v-else class="-my-2 md:-mx-6 lg:-mx-8 grid grid-cols-2 sm:grid-cols-2 gap-4">
            <div class="col-span-1">
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow">
                    <div class="px-4 py-5 sm:px-6">
                        <h1 class="text-lg font-bold">Payments</h1>
                    </div>
                    <div class="px-4 py-2 sm:p-2">
                        <apex-chart type="area" height='300' width='100%' class="justify-end"
                                :options="{
                                    chart: {
                                        toolbar: {
                                            show: false,
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    fill: {
                                        gradient: {
                                            enabled: true,
                                            opacityFrom: 0.55,
                                            opacityTo: 0
                                        }
                                    },
                                    stroke: {
                                      curve: 'smooth',
                                      width: 1.75,
                                    },
                                    xaxis: {
                                        categories: getLineChartSeries.labels
                                    },
                                    yaxis: {
                                        show: true,
                                        labels: {
                                            formatter: function(value) {
                                                var val = Math.abs(value)
                                                if (val >= 1000 && val <= 999999) {
                                                    val = (val / 1000).toFixed(0) + 'K'
                                                }
                                                if (val >= 1000000)
                                                {
                                                    val = (val / 1000000).toFixed(0) + 'M'
                                                }
                                                return '$'+val
                                            } 
                                        }
                                    },
                                    grid: {
                                        show: false,
                                    },
                                    
                                }"
                                :series="[{
                                    name: getLineChartSeries.name,
                                    data: getLineChartSeries.values
                                }]"
                        ></apex-chart>
                    </div>
                </div>
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow mt-4">
                    <div class="px-4 py-2 sm:px-6">
                        <h1 class="text-lg font-bold">Top Surgeons</h1>
                    </div>
                    <div class="py-2 sm:px-2">
                        <ul role="list" class="divide-y divide-gray-100">
                            <li v-for="surgeon in topSurgeons()" class="relative py-5">
                                <div class="px-2 sm:px-2 lg:px-4">
                                    <div class="mx-auto flex max-w-4xl justify-between gap-x-6">
                                        <a :href="surgeon.show_route">
                                            <div class="flex min-w-0 gap-x-4">
                                                <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="surgeon.avatar" alt="">
                                                <div class="min-w-0 flex-auto">
                                                    <p class="text-sm font-semibold leading-6 text-gray-900">{{ surgeon.name }}</p>
                                                    <p class="mt-1 truncate text-xs leading-5 text-gray-500">NPI: {{ surgeon.npi }}</p>
                                                </div>
                                            </div>
                                        </a>
                                        <div class="flex shrink-0 items-center gap-x-4">
                                            <div class="hidden sm:flex sm:flex-col sm:items-end">
                                                <p class="text-md font-bold text-green-600 sm:text-lg">
                                                    {{ moneyToString(surgeon.value) }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>   
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-span-1">
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow">
                    <div class="px-4 py-2 sm:px-6">
                        <h1 class="text-lg font-bold">Top Products</h1>
                    </div>
                    <div class="py-2 sm:px-2">
                        <ul role="list" class="divide-y divide-gray-100">
                            <li v-for="products in topProducts()" class="relative py-5">
                                <div class="px-2 sm:px-2 lg:px-4">
                                <div class="mx-auto flex max-w-4xl justify-between gap-x-6">
                                    <div class="flex min-w-0 gap-x-4">
                                    <div class="min-w-0 flex-auto">
                                        <p class="text-sm font-semibold leading-6 text-gray-900">
                                        <div>
                                            <span class="absolute inset-x-0 -top-px bottom-0"></span>
                                            {{ products.key }}
                                        </div>
                                        </p>
                                        
                                    </div>
                                    </div>
                                    <div class="flex shrink-0 items-center gap-x-4">
                                    <div class="hidden sm:flex sm:flex-col sm:items-end">
                                        <p class="text-md font-bold text-green-600 sm:text-lg">
                                            {{ moneyToString(products.product_totals.value) }}
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </li>   
                        </ul>
                    </div>
                </div>
                <div class="overflow-hidden rounded-lg bg-gray-50 bg-white shadow mt-4">
                    <div class="px-4 py-5 sm:px-6">
                        <h1 class="text-lg font-bold">Natures of Payment</h1>
                    </div>
                    <div class="px-4 py-2 sm:p-2">
                        <apex-chart type="donut" height='300' width='100%' class="justify-end"
                                :options="{
                                    chart: {
                                        toolbar: {
                                            show: false,
                                        }
                                    },
                                    plotOptions: {
                                        pie: {
                                            donut: {
                                                size: '80%',
                                            }
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    stroke: {
                                      lineCap: 'round',
                                    },
                                    legend: {
                                        position: 'right',
                                        formatter: function(value) {
                                                var val = value
                                                if (val.length > 20) {
                                                    val = val.substring(0, 20)+'...'
                                                }
                                                return val
                                            } 
                                    },
                                    grid: {
                                        show: false,
                                    },
                                    tooltip: {
                                        y: {
                                                formatter: function(value) {
                                                var val = Math.abs(value)
                                                
                                                return moneyToString(val)
                                            }
                                        }
                                    },
                                    labels: getPieChartSeries.labels
                                }"
                                :series="getPieChartSeries.values"
                        ></apex-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        sunshineTableRoute: {
            type: String,
            required: true,
        }
    },
    data() {
        return{
            sunshineTableData: {},
            isLoading: true,
            fullData: {},
        }
    },
    computed: {
            getLineChartSeries () {
                var series = {
                    'labels':[],
                    'values':[],
                    'name':'Payment Total'
                };
                this.fullData.year_totals.forEach(
                    function (item) {
                        series.labels.unshift(item.key)
                        series.values.unshift(Math.round(item.year_totals.value))
                    }
                );
                
                return series;
            },
            getPieChartSeries () {
                
                var series = {
                    'labels':[],
                    'values':[],
                }
                
                this.fullData.aggregations.aggs.buckets[0].nature_of_payment.buckets.forEach(function (item) {
                    series.labels.unshift(item.key);
                    series.values.unshift(Math.round((item.nature_totals.value + Number.EPSILON) * 100) / 100)
                })
                
                return series;
            },
    },
    created() {
        this.loadSunshineData();
    },
    methods: {
        async loadSunshineData() {
            try {
                this.isLoading = true;
                const response = await axios.get(this.sunshineTableRoute);
                this.fullData = response.data;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        moneyToString( num ) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            return formatter.format(this.nullToZero(num));
        },
        nullToZero(num) {
            return num === null ? 0 : parseFloat(num);
        },
        productArray (payment) {
            var arr = [payment._source.product_1, payment._source.product_2,payment._source.product_3,payment._source.product_4,payment._source.product_5];
                var clean_arr = [];
                arr.forEach(function (item) {
                    if (item !== 'NA') {
                        if (item.length > 30) {
                            item = item.substring(0, 30)+'...'
                        }
                        clean_arr.push(item);
                    }
                })

                return clean_arr;
        },
        topProducts () {
            var product_aggregations = this.fullData.aggregations.aggs.buckets[0].product.buckets;

            return product_aggregations.slice(0,5);     
        },

        topSurgeons () {
            var surgeon_aggregations = this.fullData.surgeons;

            return surgeon_aggregations.slice(0,5);     
        },
    },
}
</script>
